<template>
	<gmaps
    :searchValue="searchValue"
	:mapOptions="mapOptions"
	:locations="listOfAgenciesLocations"
	:elementsList="parsedAgenciesList"
	:useMyCurrentLocation="useMyCurrentLocation"
	:useAgencyLocation="useAgencyLocation"
	:agencyLocation="agencyLocation"
	@markerClicked="handleMarkerClick"
	@initalPositionMoved="emit('initalPositionMoved')"
	@mapError="emit('mapError')"/>
</template>

<script setup>
import Gmaps from '@/components/features/agencies/Gmap'

/* Vue */
import { ref, computed, watch } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['openAgenciesDetail', 'initalPositionMoved', 'mapError'])

/* mapGetters */
const { getAgenciesList } = mapGetters(moduleMapper.AGENCIES)
const { getMobileAppState } = mapGetters()

const props = defineProps({
    searchValue: String,
	agenciesList: Array,
	useMyCurrentLocation: Boolean,
	useAgencyLocation: Boolean,
	agencyLocation: Object
})

const mapOptions = ref({
	center: getMobileAppState.value ? { lat: -8.841292, lng: 13.332197 } : { lat: -8.841292, lng: 13.232197 }, /* Luanda */
	zoom: getMobileAppState.value ? 10 : 10.5, /* default */
	disableDefaultUI: true,
	fullscreenControl: false,
	clickableIcons: false
})

const parsedAgenciesList = computed(() => {
	return getAgenciesList.value.map(obj => {
		return {
			...obj,
			title: t('agencies.pinTitle')
		}
	})
})

const listOfAgenciesLocations = computed(() => {
	return props.agenciesList.map(agency => {
		return {
			id: agency.id,
			lat: agency.coordinates.latitude,
			lng: agency.coordinates.longitude
		}
	})
})

const handleMarkerClick = agency => {
	emit('openAgenciesDetail', agency)
}
</script>

<style lang="scss" scoped>
</style>
